import {
  SignInBegin,
  SignInSuccess,
  SignIsFailure,
  SignOutBegin,
  SignOutSuccess,
  SignUpBegin,
  SignUpFailure,
  SignUpSuccess,
  SaveUserDataBegin,
  SaveUserDataSuccess,
  SaveUserDataFailure,
  SignUpGuardianBegin,
  SignUpGuardianSuccess,
  SignUpGuardianFailure,
  SignInGuardianBegin,
  SignInGuardianSuccess,
  SignInGuardianFailure,
  SignUpGuardianInfoBegin,
  SignUpGuardianInfoSuccess,
  SignUpGuardianInfoFailure
} from "./actions"

import { validateForm } from "../validation"
import configs from "../../configs"

const msieversion = () => {
  const ua = window.navigator.userAgent

  const msie = ua.indexOf("MSIE ")

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10)
  }

  const trident = ua.indexOf("Trident/")
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf("rv:")
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10)
  }

  const edge = ua.indexOf("Edge/")
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10)
  }

  // other browser
  return false
}

export const getCookie = name => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2)
    return parts
      .pop()
      .split(";")
      .shift()

  return false
}

export const setCookie = (name, value, options) => {
  const opts = options || {}

  let { expires } = opts

  if (typeof expires === "number" && expires) {
    const d = new Date()
    d.setTime(d.getTime() + expires * 24 * 3600 * 1000)
    opts.expires = d
    expires = d
  }
  if (expires && expires.toUTCString) {
    opts.expires = expires.toUTCString()
  }

  let updatedCookie = `${name}=${value}`

  Object.keys(options).forEach(key => {
    const propValue = options[key]

    if (msieversion()) {
      if (key === "expires") {
        if (propValue) {
          updatedCookie += `; ${key}`
        }
      } else {
        updatedCookie += `; ${key}`
      }
    } else {
      updatedCookie += `; ${key}`
    }

    if (propValue !== true) {
      if (msieversion()) {
        if (key === "expires") {
          if (propValue) {
            updatedCookie += `=${propValue}`
          }
        } else {
          updatedCookie += `=${propValue}`
        }
      } else {
        updatedCookie += `=${propValue}`
      }
    }
  })

  document.cookie = updatedCookie
}

export const deleteCookie = name => {
  setCookie(name, "", { expires: -1, path: "/" })
}

const getUser = token => {
  return fetch(`${configs.api.base}/api/user/profile/`, {
    method: "GET",
    headers: new Headers({
      Authorization: `Bearer ${token}`
    })
  })
}

export const fetchDisabilities = () => {
  return new Promise((resolve, reject) => {
    fetch(`${configs.api.base}/api/disabilities/list/`, {
      method: "GET"
    })
      .then(response => {
        if (response.status === 200) {
          return response.json()
        }

        return null
      })
      .then(data => {
        if (data) {
          resolve(data)
        } else {
          reject()
        }
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const saveUserData = (body, token) => {
  return dispatch => {
    let responseStatus

    dispatch(SaveUserDataBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/user/profile/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      })
        .then(response => {
          responseStatus = response.status

          return response.json()
        })
        .then(data => {
          if (responseStatus === 200) {
            resolve()
            dispatch(
              SaveUserDataSuccess({
                name: data.first_name,
                last_name: data.last_name,
                address: data.address,
                phone: data.phone,
                ndis_number: data.ndis_number || "",
                primary_disability: data.primary_disability
                  ? String(data.primary_disability)
                  : "",
                secondary_disability: data.secondary_disability
                  ? String(data.secondary_disability)
                  : "",
                token
              })
            )
          } else if (responseStatus === 400) {
            reject(data)
            dispatch(SaveUserDataFailure())
          }
        })
        .catch(e => {
          reject()
          dispatch(SaveUserDataFailure(e))
        })
    })
  }
}

export const signIn = user => {
  return dispatch => {
    let invalidFields

    dispatch(SignInBegin())

    return new Promise((resolve, reject) => {
      invalidFields = validateForm(user)

      if (
        Object.entries(invalidFields).length === 0 &&
        invalidFields.constructor === Object
      ) {
        fetch(`${configs.api.base}/api/auth/login/`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: user.email.value,
            password: user.password.value
          })
        })
          .then(response =>
            response.json().then(body => ({ status: response.status, body }))
          )
          .then(data => {
            const { status, body } = data
            if (status !== 200) {
              const error = { generalErrorMessage: body.error || body.errors }
              dispatch(SignIsFailure())
              reject(error)
            } else {
              getUser(body.token)
                .then(response => {
                  if (response.status === 200) {
                    setCookie("loggined", JSON.stringify(body.token), {
                      path: "/",
                      expires: user.keepMeSignIn.checked ? 7 : 0
                    })

                    return response.json()
                  }

                  return null
                })
                .then(rUser => {
                  if (rUser) {
                    dispatch(
                      SignInSuccess({
                        name: rUser.first_name,
                        last_name: rUser.last_name,
                        address: rUser.address,
                        phone: rUser.phone,
                        list_role: rUser.list_role,
                        ndis_number: rUser.ndis_number || "",
                        primary_disability: rUser.primary_disability
                          ? String(rUser.primary_disability)
                          : "",
                        secondary_disability: rUser.secondary_disability
                          ? String(rUser.secondary_disability)
                          : "",
                        token: body.token
                      })
                    )
                    resolve()
                  } else {
                    dispatch(SignIsFailure())
                    reject(invalidFields)
                  }
                })
            }
          })
      } else {
        dispatch(SignIsFailure())
        reject(invalidFields)
      }
    })
  }
}

export const autoSignIn = token => {
  return dispatch => {
    dispatch(SignInBegin())

    return new Promise((resolve, reject) => {
      getUser(token)
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }
          dispatch(SignIsFailure())
          reject()
          return null
        })
        .then(data => {
          if (data) {
            const ndisNumber = data.ndis_number || ""
            const primaryDisability = data.primary_disability
              ? String(data.primary_disability)
              : ""
            const secondaryDisability = data.secondary_disability
              ? String(data.secondary_disability)
              : ""

            dispatch(
              SignInSuccess({
                name: data.first_name,
                last_name: data.last_name,
                address: data.address,
                list_role: data.list_role,
                phone: data.phone,
                ndis_number: ndisNumber,
                primary_disability: primaryDisability,
                secondary_disability: secondaryDisability,
                token
              })
            )

            resolve({ ndisNumber, primaryDisability, secondaryDisability })
          } else {
            dispatch(SignIsFailure())
            reject()
          }
        })
    })
  }
}

export const signOut = () => {
  return dispatch => {
    dispatch(SignOutBegin())

    setTimeout(() => {
      deleteCookie("loggined")
      dispatch(SignOutSuccess())
    }, 1000)
  }
}

export const signUp = user => {
  return dispatch => {
    dispatch(SignUpBegin())

    return new Promise((resolve, reject) => {
      const invalidFields = validateForm(user)

      if (
        Object.entries(invalidFields).length === 0 &&
        invalidFields.constructor === Object
      ) {
        fetch(`${configs.api.base}/api/auth/register/`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            first_name: user.firstName.value,
            last_name: user.lastName.value,
            email: user.email.value,
            password: user.password.value
          })
        })
          .then(response => {
            return response.json()
          })
          .then(data => {
            if (data.request && data.Id) {
              dispatch(SignUpSuccess())
              resolve(data.request)
            } else if (data.password || data.email) {
              const dataErrors = {}

              Object.keys(data).map(dataKey => {
                dataErrors[dataKey] = {
                  ...user[dataKey],
                  message: data[dataKey][0]
                }

                return null
              })

              dispatch(SignUpFailure())
              reject(dataErrors)
            }
          })
      } else {
        dispatch(SignUpFailure())
        reject(invalidFields)
      }
    })
  }
}

export const resetPassword = user => {
  return new Promise((resolve, reject) => {
    const invalidFields = validateForm(user)

    if (
      Object.entries(invalidFields).length === 0 &&
      invalidFields.constructor === Object
    ) {
      fetch(`${configs.api.base}/api/auth/reset-password/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: user.email.value,
          reset_password_key: user.reset_password_key.value,
          new_password: user.password.value,
          confirm_password: user.confirm_password.value
        })
      })
        .then(response => {
          if (response.status === 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          if (data) {
            const error = {
              generalErrorMessage:
                data.password ||
                data.confirm_password ||
                data.detail ||
                data.error ||
                data.message
            }
            reject(error)
          } else {
            resolve()
          }
        })
    } else {
      reject(invalidFields)
    }
  })
}

export const forgotPassword = user => {
  return new Promise((resolve, reject) => {
    const invalidFields = validateForm(user)

    if (
      Object.entries(invalidFields).length === 0 &&
      invalidFields.constructor === Object
    ) {
      fetch(`${configs.api.base}/api/auth/forgot-password/`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: user.email.value
        })
      })
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (data.Message) {
            resolve(data.Message)
          } else if (data.error) {
            const field = user.email
            field.message = data.error
            reject(field)
          }
        })
    } else {
      reject(invalidFields)
    }
  })
}

export const setNewPassword = (token, body) => {
  return new Promise((resolve, reject) => {
    fetch(`${configs.api.base}/api/auth/update-password/`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        if (data.message) {
          resolve(data.message)
        } else {
          reject(data)
        }
      })
      .catch(() => {
        reject()
      })
  })
}

export const verifyEmail = code => {
  return new Promise((resolve, reject) => {
    if (code) {
      fetch(`${configs.api.base}/api/auth/verify-email/?code=${code}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          if (response.status !== 200) {
            reject()
          }

          return response.json()
        })
        .then(data => {
          resolve(data.message || data.error)
        })
        .catch(() => {
          reject()
        })
    } else {
      reject()
    }
  })
}

export const signUpGuardian = (user, token) => {
  return dispatch => {
    dispatch(SignUpGuardianBegin())

    return new Promise((resolve, reject) => {
      const invalidFields = validateForm(user)

      if (
        Object.entries(invalidFields).length === 0 &&
        invalidFields.constructor === Object
      ) {
        fetch(`${configs.api.base}/api/auth/verify-guardian/`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            preferred_name: user.preferred_name.value,
            verify_email_code: token,
            password: user.password.value,
            confirm_password: user.confirm_password.value
          })
        })
          .then(response => {
            return response.json()
          })
          .then(data => {
            if (data.Error) {
              reject({ errorMessage: data.Error })
              dispatch(SignUpGuardianFailure())
            } else {
              resolve(data)
              dispatch(SignUpGuardianSuccess())
            }
          })
      } else {
        reject({ fields: invalidFields })
        dispatch(SignUpGuardianFailure())
      }
    })
  }
}

export const signUpGuardianInfo = token => {
  return dispatch => {
    dispatch(SignUpGuardianInfoBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/core/help/1/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }
          dispatch(SignUpGuardianInfoFailure())
          reject()
          return null
        })
        .then(data => {
          if (data) {
            dispatch(SignUpGuardianInfoSuccess(data))
            resolve()
          }
        })
        .catch(() => {
          dispatch(SignUpGuardianInfoFailure())
          reject()
        })
    })
  }
}

export const signInGuardian = access => {
  return dispatch => {
    dispatch(SignInGuardianBegin)

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/guardian/activity/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access}`
        }
      }).then(response => {
        if (response.status === 200) {
          getUser(access)
            .then(response2 => {
              if (response2.status === 200) {
                setCookie("loggined", JSON.stringify(access), {
                  path: "/",
                  expires: 0
                })

                return response2.json()
              }

              return null
            })
            .then(rUser => {
              if (rUser) {
                dispatch(
                  SignInGuardianSuccess({
                    preferred_name: rUser.preferred_name,
                    name: rUser.first_name,
                    list_role: rUser.list_role,
                    last_name: rUser.last_name,
                    phone: rUser.phone,
                    token: access
                  })
                )
                resolve()
              } else {
                dispatch(SignInGuardianFailure())
                reject()
              }
            })
        } else {
          dispatch(SignInGuardianFailure())
          reject()
        }
      })
    })
  }
}
